module.exports = __webpack_public_path__ + "static/media/passive_info3.e75ec2ad.svg";